<div class="content">
  <div class="title" translate="parameters/whatsapp-templates/preview/title"></div>
  <div class="wa-message">
    <div *ngIf="seeMoreOptionsContainerMarginTop > 0" class="wa-message-backdrop"></div>
    <div class="header media-wrapper" *ngIf="imageSrc || videoSrc || documentSrc" [class.document-type]="documentSrc">
      <img *ngIf="imageSrc" [src]="imageSrc" />
      <video *ngIf="videoSrc" class="video" [src]="videoSrc" width="100%" preload="" controls=""></video>
      <div *ngIf="documentSrc" class="document-wrapper">
        <img src="assets/whatsapp-cloud-api-examples/pdf-icon.svg" />
        <div class="document-metadata">
          <div class="filename">{{ mediaMetadata?.filename }}</div>
          <small class="text-muted">{{ mediaMetadata?.weight }} Ko &#x2022; PDF</small>
        </div>
      </div>
    </div>
    <div class="limited-time-offer" [class.no-header]="!imageSrc && !videoSrc && !documentSrc" *ngIf="limitedTimeOffer">
      <div class="limited-time-offer-logo">
        <ion-icon name="pricetag-outline"></ion-icon>
      </div>
      <div>
        <div class="limited-time-offer-text">{{ limitedTimeOffer.text }}</div>
        <div
          class="limited-time-offer-expiration-date"
          translate="parameters/whatsapp-templates/preview/expired-date-example"></div>
        <div class="limited-time-offer-code" *ngIf="limitedTimeOffer.code">
          <span translate="parameters/whatsapp-templates/preview/code-prefix"></span>&nbsp;
          <span>{{ limitedTimeOffer.code }}</span>
        </div>
      </div>
    </div>
    <strong class="header-text">{{ headerText }}</strong>
    <div class="body">
      <p class="body-formatted" [class.truncated]="bodyTruncated" [innerHTML]="bodyFormatted"></p>
      <div *ngIf="bodyTruncated" id="show-more-trigger" class="text-muted" (click)="bodyTruncated = false">
        {{ 'parameters/whatsapp-templates/preview/show-more-text' | translate }}
      </div>
      <div class="text-muted">{{ footerText || '&nbsp;' }}</div>
      <div class="timestamp text-muted">{{ actualTimeLabel }}</div>
    </div>
    <div class="footer">
      <div class="buttons">
        <div class="button" *ngFor="let button of mainButtons" [ngClass]="button.type">
          <ion-icon *ngIf="button.type === WhatsappTemplateButtonTypeEnum.COPY_CODE" name="copy-outline"></ion-icon>
          <ion-icon *ngIf="button.type === WhatsappTemplateButtonTypeEnum.PHONE_NUMBER" name="call-outline"></ion-icon>
          <ion-icon
            class="quick-reply-icon"
            *ngIf="button.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY"
            name="return-up-back-outline"></ion-icon>
          <ion-icon *ngIf="button.type === WhatsappTemplateButtonTypeEnum.URL" name="open-outline"></ion-icon>
          <span [matTooltip]="button['href']" [matTooltipDisabled]="!button['href']">
            <ng-container *ngIf="button.type === WhatsappTemplateButtonTypeEnum.COPY_CODE; else defaultButtonLabel">
              {{ 'parameters/whatsapp-templates/content/buttons/label/copy-code' | translate }}
            </ng-container>
            <ng-template #defaultButtonLabel>
              {{ button.text }}
            </ng-template>
          </span>
        </div>
        <div class="button" *ngIf="buttons?.length > 3" (click)="seeMoreOptions()">
          <ion-icon name="list-outline"></ion-icon>
          <span translate="parameters/whatsapp-templates/preview/see-more-options"></span>
        </div>
        <div
          id="see-more-options-container"
          [style.height.px]="seeMoreOptionsContainerHeight"
          [style.margin-top.px]="seeMoreOptionsContainerMarginTop">
          <div class="see-more-options-slider text-center"></div>
          <div class="see-more-options-title">
            <ion-icon class="close-options" (click)="closeMoreOptions()" name="close-outline"></ion-icon>
            <strong translate="parameters/whatsapp-templates/preview/see-more-options-title"></strong>
          </div>

          <div class="button" *ngFor="let button of buttons" [ngClass]="button.type" (click)="closeMoreOptions()">
            <ion-icon *ngIf="button.type === WhatsappTemplateButtonTypeEnum.COPY_CODE" name="copy-outline"></ion-icon>
            <ion-icon
              *ngIf="button.type === WhatsappTemplateButtonTypeEnum.PHONE_NUMBER"
              name="call-outline"></ion-icon>
            <ion-icon
              *ngIf="button.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY"
              name="return-up-back-outline"></ion-icon>
            <ion-icon *ngIf="button.type === WhatsappTemplateButtonTypeEnum.URL" name="open-outline"></ion-icon>
            <span [matTooltip]="button['href']" [matTooltipDisabled]="!button['href']">
              <ng-container *ngIf="button.type === WhatsappTemplateButtonTypeEnum.COPY_CODE; else defaultButtonLabel">
                {{ 'parameters/whatsapp-templates/content/buttons/label/copy-code' | translate }}
              </ng-container>
              <ng-template #defaultButtonLabel>
                {{ button.text }}
              </ng-template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
